import useSWR from 'swr'
import { useAuthToken } from './useAuthToken'
import { needsAnalysisService } from '@/services/needsAnalysisService'
import { createFetcher } from '@/services/api'
import type { NeedsAnalysisContextResponse } from '@/types/learner-portal'

export function useNeedsAnalysisStatus() {
  const { getToken, isSignedIn } = useAuthToken()

  const fetcher = async (url: string) => {
    const f = createFetcher(getToken)
    return await f(url)
  }

  const { data, error, isLoading } = useSWR<NeedsAnalysisContextResponse>(
    isSignedIn ? needsAnalysisService.getStatusUrl() : null,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  )

  // Check if survey is completed
  const hasCompletedNeedsAnalysis = !!data?.needs_analysis?.completed_at

  return {
    hasCompletedNeedsAnalysis,
    isLoading,
    error,
    needsAnalysisData: data?.needs_analysis ?? null,
  }
}
